
import { defineComponent, ref, onMounted } from 'vue';

const COOKIE_CONSENT_KEY = 'cookie_consent';

export default defineComponent({
  name: 'CookieConsent',
  setup() {
    const showBanner = ref(false);

    const checkConsent = () => {
      const consent = localStorage.getItem(COOKIE_CONSENT_KEY);
      return consent === 'accepted' || consent === 'declined';
    };

    const acceptCookies = () => {
      localStorage.setItem(COOKIE_CONSENT_KEY, 'accepted');
      showBanner.value = false;
      // Here you can initialize analytics, tracking, etc.
      initializeCookies();
    };

    const declineCookies = () => {
      localStorage.setItem(COOKIE_CONSENT_KEY, 'declined');
      showBanner.value = false;
      // Remove any non-essential cookies if needed
      removeNonEssentialCookies();
    };

    const initializeCookies = () => {
      // Initialize analytics, tracking cookies, etc.
      // Example: Google Analytics, Facebook Pixel, etc.
      console.log('Cookies accepted - initializing tracking');
    };

    const removeNonEssentialCookies = () => {
      // Remove non-essential cookies if user declined
      console.log('Cookies declined - removing non-essential cookies');
    };

    const openPrivacyPolicy = () => {
      // Navigate to privacy policy page or open modal
      // You can customize this based on your needs
      window.open('#/privacy', '_blank');
    };

    onMounted(() => {
      // Show banner only if user hasn't made a choice yet
      if (!checkConsent()) {
        showBanner.value = true;
      }
    });

    return {
      showBanner,
      acceptCookies,
      declineCookies,
      openPrivacyPolicy
    };
  }
});
